export const billingAddressConstants = {
  CREATE_BILLINGADDRESS: 'CREATE_BILLINGADDRESS',
  RETRIEVE_BILLINGADDRESSS: 'RETRIEVE_BILLINGADDRESSS',
  UPDATE_BILLINGADDRESS: 'UPDATE_BILLINGADDRESS',
  DELETE_BILLINGADDRESS: 'DELETE_BILLINGADDRESS',
  DELETE_ALL_BILLINGADDRESS: 'DELETE_ALL_BILLINGADDRESS',
}
